import { render, staticRenderFns } from "./agv-order-select.vue?vue&type=template&id=53efdb0f&scoped=true&lang=pug&"
import script from "./agv-order-select.vue?vue&type=script&lang=js&"
export * from "./agv-order-select.vue?vue&type=script&lang=js&"
import style0 from "./agv-order-select.vue?vue&type=style&index=0&id=53efdb0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53efdb0f",
  null
  
)

export default component.exports